import { describeResource } from '@siteless/resource';
import { database } from '../../config/firebase';
import { oneLeagueResourceSchema, OneLeagueResourceType } from './One';
import {
  collectionGroup,
  query,
  where,
  getDocs,
  getDoc,
  collection,
  DocumentReference,
  DocumentData,
} from 'firebase/firestore';
import { nonNullable } from '@siteless/util';
import { uniq, uniqBy } from 'lodash';

export type AllLeaguesForUserResourceType =
  NonNullable<OneLeagueResourceType>[];

type LeagueReferenceType = DocumentReference<DocumentData>;

let AllLeaguesForUserResource = describeResource('AllLeaguesForUser', {
  get: async (userId?: string) => {
    if (!userId) return [];

    let leagueRefs: LeagueReferenceType[] = [];

    let userLeaguesSnapshot = await getDocs(
      query(
        collectionGroup(database, 'leagueMemberUserIds'),
        where('userId', '==', userId),
      ),
    );

    userLeaguesSnapshot.forEach(doc => {
      let parentRef = doc.ref.parent.parent;
      if (parentRef === null) return;
      leagueRefs.push(parentRef);
    });

    let leagueDataPromises: Promise<any>[] = [];

    leagueRefs.forEach(leagueDataRef => {
      if (leagueDataRef === null) return;
      leagueDataPromises.push(
        (async () => {
          let document = await getDoc(leagueDataRef);
          if (!document.exists()) return null;

          let memberUserIds: string[] = [];
          (
            await getDocs(
              collection(
                database,
                'leagues',
                document.id,
                'leagueMemberUserIds',
              ),
            )
          ).forEach(doc => {
            memberUserIds.push(doc.data().userId);
          });

          return oneLeagueResourceSchema.parse({
            ...document.data(),
            id: document.id,
            memberUserIds,
          });
        })(),
      );
    });

    let allLeagues = uniqBy(
      (await Promise.all(leagueDataPromises)).filter(nonNullable),
      item => item.id,
    );

    return allLeagues;
  },
});

export default AllLeaguesForUserResource;
